import vacanciesConstants    from './vacancies.constants';
import vacanciesInitialState from './vacancies.state';

function vacanciesReducer(state = vacanciesInitialState, action) {
  switch (action.type) {
    case vacanciesConstants.GET_VACANCIES_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case vacanciesConstants.GET_VACANCIES_SUCCESS:
      state = {
        ...state,
        contactButtonName: action.contactButtonName || vacanciesInitialState.contactButtonName,
        headImage:         action.headImage || vacanciesInitialState.headImage,
        vacanciesIsLoaded: true,
        isIndexed:         action.isIndexed || vacanciesInitialState.isIndexed,
        items:             action.items || vacanciesInitialState.items,
        inCatalogLabel:    action.inCatalogLabel || vacanciesInitialState.inCatalogLabel,
        inCatalogLink:     action.inCatalogLink || vacanciesInitialState.inCatalogLink,
        label:             action.label || vacanciesInitialState.label,
        loading:           false,
        meta:              {
          title: action.metaTitle || vacanciesInitialState.meta.title,
          meta:  {
            keywords:    action.keywords || vacanciesInitialState.meta.meta.keywords || '',
            description: action.description || vacanciesInitialState.meta.meta.description || '',
            canonical:   action.canonical || vacanciesInitialState.meta.meta.canonical || '',
          },
        },
        template:          action.template || vacanciesInitialState.template,
      };
      break;

    case vacanciesConstants.GET_VACANCIES_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default vacanciesReducer;